<template>
    <form @submit.prevent="submitRegister">
      <label for="name">نام</label>
      <input id="name" v-model="name" type="text" required />
      <label for="family">نام خانوادگی</label>
      <input id="family" v-model="family" type="text" required />
      <button type="submit">ثبت‌ نام</button>
    </form>
</template>
<script setup>
  import { ref,defineProps } from 'vue'
  import { useRouter } from 'vue-router'
  import { useUserStore } from '@/stores/user'
  import { useAlertStore } from '@/stores/alert'
  const userStore = useUserStore()
  const alertStore = useAlertStore()
  const props = defineProps({
    imageId: Number
  });
  const name = ref('')
  const family = ref('')
  const router = useRouter()
  const submitRegister = async () => {
    if(name.value !== '' && family.value !== ''){
      const res = await userStore.register(name.value,family.value,props.imageId);
      if(res) {
        localStorage.setItem('isLogin', true)
        window.dispatchEvent(new Event("storage"));
        router.push({ name: 'dashboard' })
      }else{
        alertStore.msg = 'خطا در ثبت‌نام.'
      }
    }else{
      alertStore.msg = 'مشخصات ناقص است. لطفاً دوباره تلاش کنید.'      
    }
  }
</script>

<style scoped>
  form {
    width: 100%;
  }
  .msg{
    border-radius: 10px;
    background-color: #5e6295;
    color: #fefff8;
    padding: 10px;
    text-align: center;
    margin: 5px auto;
  }
  label,
  input,
  button {
    display: block;
    width: 100%;
    margin: 5px 0;
  }
  button{
    background-color: green;
    color: white;
    padding: 15px;
    border-radius: 10px;
    border: none;
    margin-top: 10px;
  }
  input {
    padding: 10px;
    box-sizing: border-box;
    outline: none;
    border-radius: 10px;
    background-color: #edefff;
    border: none;
  }
</style>
